import { createSelector } from 'reselect';
import precise from '../modules/precise';
import subTotalFeesCredit from './subtotalFeesAndCredit.selector';
import renewalPenaltyTotal from './renewalPenaltyTotal.selector';
import plateFeeTotal from './plateFeeTotal.selector';
import transferFeeTotal from './transferFeeTotal.selector';

const subTotalFeesCreditSel = state => subTotalFeesCredit(state);
const applyPenaltyFeeSel = state => state.registration.applyPenaltyFee;
const penaltyFeeSel = state => renewalPenaltyTotal(state);
const initialFeeSel = state => state.registration.initialRegistrationFee;
const plateFeeSel = state => plateFeeTotal(state);
const transferFeeSel = state => transferFeeTotal(state);
const personalizedPlateFeeSel = state => state.registration.personalizedPlateFee;
const specialtyPlateTotalSel = state => state.registration.specialtyPlateTotal;
const parkPlacardFeeSel = state => state.registration.parkPlacardFee;
const mailFeeSel = state => state.registration.mailFee;
const mailFeeShowCustomAmountSel = state => state.registration.mailFeeShowCustomAmount;
const mailFeeCustomFeeSel = state => state.registration.mailFeeCustomFee;

const add = (...values) => {
  return values.reduce((acc, val) => {
    return acc + Number(val);
  }, 0);
};

const registrationSelector = createSelector(
  [
    subTotalFeesCreditSel,
    applyPenaltyFeeSel,
    penaltyFeeSel,
    initialFeeSel,
    plateFeeSel,
    transferFeeSel,
    personalizedPlateFeeSel,
    specialtyPlateTotalSel,
    parkPlacardFeeSel,
    mailFeeSel,
    mailFeeShowCustomAmountSel,
    mailFeeCustomFeeSel,
  ],
  (
    subtotal,
    applyPenalty,
    penaltyFee,
    initial,
    plateFee,
    transferFee,
    personalizedPlateFee,
    specialtyPlateTotal,
    parkPlacardFee,
    mailFee,
    mailFeeShowCustomAmount,
    mailFeeCustomFee,
  ) => {
    let total = Number(subtotal);
    total += add(plateFee, transferFee);
    total += add(initial, personalizedPlateFee, specialtyPlateTotal, parkPlacardFee);

    if (applyPenalty) {
      total += Number(penaltyFee);
    }

    if (mailFeeShowCustomAmount) {
      total += Number(mailFeeCustomFee);
    } else {
      total += Number(mailFee);
    }

    return precise(total);
  },
);

export default registrationSelector;



// WEBPACK FOOTER //
// ./src/selectors/registrationTotal.selector.js